<template>
  <v-container>
    <v-row>
      <v-col>
        <BranchYearInfoSubView :branchYear="branchYear" @snack="throwSnack"></BranchYearInfoSubView>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <BranchYearTeamSubView
          :branchId="branchId"
          :yearId="yearId"
          @snack="throwSnack"></BranchYearTeamSubView>
      </v-col>
    </v-row>
  </v-container>
</template>
<script setup lang="ts">
import { IBranchYearDTO } from '@/dtos';
import BranchYearInfoSubView from './BranchYearInfoSubView.vue';
import BranchYearTeamSubView from './BranchYearTeamSubView.vue';
import { useSnack } from '@/helpers';
import { SNACKSTATUS } from '@/stores/util';
import { computed } from 'vue';
interface Props {
  branchYear: IBranchYearDTO;
  branchId: string;
  yearId: string;
}
const props = defineProps<Props>();
const branchYear = computed(() => props.branchYear);
const branchId = computed(() => props.branchId);
const yearId = computed(() => props.yearId);
const emit = defineEmits<{
  (e: 'snack', objType: string, snackType: SNACKSTATUS, err?: string): void;
}>();
const { throwSnack } = useSnack(emit);
</script>
